import { Box, CircularProgress, Typography } from "@mui/material";
import { tokens } from "../theme";


export default function LoadingState({
  message = "Cargando datos…",
  minHeight = "50vh",
}) {
  const colors = tokens();

  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          minWidth: 240,
          maxWidth: 360,
          textAlign: "center",
          px: 4,
          py: 4,
          borderRadius: "16px",
          backgroundColor: colors.primary[400],
          boxShadow:`0 8px 24px ${colors.grey[700]}`,
        }}
      >
        <CircularProgress size={34} sx={{ mb: 2, color: colors.green[200] }} />
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 0.5 }}>
          Cargando
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Box>
  );
}